import styled from '@emotion/styled'
import { Box, Paper, Typography, Button, Alert, Chip } from '@mui/material'
import { typography } from '@resiliatech/birdsong'
import { colors } from '../../../../Themes/Colors'

export const LoadingContainer = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 32px;
`

export const ActionsContainer = styled(Box)`
  display: flex;
  gap: 16px;
`

export const BackButton = styled(Button)`
  background-color: #6b46c1;
  color: white;
  text-transform: none;
  font-weight: 500;

  &:hover {
    background-color: #5a3aa7;
  }
`

export const SuccessAlert = styled(Alert)`
  margin-bottom: 16px;
`

export const ErrorAlert = styled(Alert)`
  margin-bottom: 16px;
`

export const InfoSection = styled(Paper)`
  padding: 24px;
  margin-bottom: 24px;
`

export const SectionHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const SectionTitle = styled(Typography)`
  ${typography.up3.semiBoldSans}
`

export const InfoGrid = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`

export const InfoItem = styled(Box)``

export const InfoLabel = styled(Typography)`
  color: ${colors.mediumGrey};
  ${typography.up1.regularSans}
`

export const InfoValue = styled(Typography)`
  ${typography.up2.regularSans}
  margin-bottom: 8px;
`

export const JobIdContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const JobId = styled(Typography)`
  font-family: 'Courier New', monospace;
  ${typography.up2.regularSans}
`

export const StatusChip = styled(Chip)``

export const CodeBlock = styled(Box)`
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  overflow: auto;
  font-size: 0.875rem;
  font-family: 'Courier New', monospace;
  white-space: pre-wrap;
  word-break: break-all;
`

export const StackTraceBlock = styled(Box)`
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  overflow: auto;
  font-size: 0.75rem;
  font-family: 'Courier New', monospace;
  white-space: pre-wrap;
  word-break: break-all;
`

export const ErrorSection = styled(Paper)`
  padding: 24px;
  margin-bottom: 24px;
`

export const ErrorTitle = styled(Typography)`
  color: ${colors.red};
  margin-bottom: 16px;
  ${typography.up3.semiBoldSans}
`

export const StackTraceLabel = styled(Typography)`
  margin-bottom: 8px;
  ${typography.up1.semiBoldSans}
`

export const RetryButton = styled(Button)`
  text-transform: none;
`
